import clsx from 'clsx';
import React, { type ReactNode } from 'react';

import styles from './EmptyPage.module.scss';

export type EmptyPageProps = {
  icon?: ReactNode;
  title?: string;
  desc?: string;
  action?: ReactNode;
  className?: string;
  minHeight?: React.CSSProperties['minHeight'];
};

/**
 * **A whole screen with nothing on it** — no results, no records yet, a filter that matched
 * nothing. Carries an icon, a title, a description and an arbitrary action node.
 *
 * Not {@link EmptyState}: that one is the inline version, sized to the card it sits inside.
 *
 * @alias no results, blank screen, nothing found, zero state page
 */
export const EmptyPage = ({ icon, title, desc, action, className, minHeight }: EmptyPageProps) => {
  return (
    <div
      className={clsx(styles.container, className)}
      style={minHeight !== undefined ? { minHeight } : undefined}
    >
      {icon && <div className={styles.icon}>{icon}</div>}
      {title && <p className={clsx('headline-large', styles.title)}>{title}</p>}

      {desc && <p className={clsx('body-large', styles.desc)}>{desc}</p>}
      {action && <div className={styles.action}>{action}</div>}
    </div>
  );
};
